<form [formGroup]="form" (submit)="$event.preventDefault()">
  <mat-card>
    <mat-card-content>
      <mat-card-title></mat-card-title>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["reportType"]}}
          @if (!reportType.disabled) {
          <span class="required"></span>
          }
        </label>
        <mat-form-field class="full-width">
          <mat-select formControlName="reportType" required placeholder="Select Report Type">
            <mat-option *ngFor="let option of reportTypesList" [value]="option[0]">{{option[1]}}</mat-option>
          </mat-select>
          <mat-error *ngIf="getErrorMessage('reportType') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["reportTitleEn"]}}
          @if (!form.get('reportTitleEn')?.disabled) {
          <span class="required"></span>
          }
        </label>
        <mat-form-field class="full-width">
          <input matInput formControlName="reportTitleEn" maxlength="501" required
            placeholder="Enter Report Title (EN)">
          <mat-error *ngIf="getErrorMessage('reportTitleEn') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">{{displayNames["reportTitleRu"]}}</label>
        <mat-form-field class="full-width">
          <input matInput formControlName="reportTitleRu" maxlength="501" placeholder="Enter Report Title (RU)">
          <mat-error *ngIf="getErrorMessage('reportTitleRu') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">{{displayNames["reportTitleKz"]}}</label>
        <mat-form-field class="full-width">
          <input matInput formControlName="reportTitleKz" maxlength="501" placeholder="Enter Report Title (KZ)">
          <mat-error *ngIf="getErrorMessage('reportTitleKz') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["initiator"]}}
          @if (!form.get('initiator')?.disabled) {
          <span class="required"></span>
          }
          <mat-spinner *ngIf="loadingFields()['initiator']" diameter="11"></mat-spinner>
        </label>
        <mat-form-field class="full-width"
          [ngClass]="_fieldHighlightService.getHighlightClasses('initiator', FieldLocation.GeneralTab)">
          <input matInput required formControlName="initiator" maxlength="500" placeholder="Enter Initiator Email"
            [matAutocomplete]="initiatorAuto">
          <mat-autocomplete #initiatorAuto="matAutocomplete"
            (optionSelected)="onEmailAutocompleteSelected($event, 'initiator', 'initiatorFullName')">
            <mat-option *ngFor="let email of getEmailAutocompleteOptions('initiator')" [value]="email">
              {{ email }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <mat-form-field class="full-width">
          <textarea matInput formControlName="initiatorFullName" maxlength="500" placeholder="Initiator Full Name"
            readonly></textarea>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["owner"]}}
          @if (!owner.disabled) {
          <span class="required"></span>
          }
          <mat-spinner *ngIf="loadingFields()['owner']" diameter="11"></mat-spinner>
        </label>
        <mat-form-field class="full-width"
          [ngClass]="_fieldHighlightService.getHighlightClasses('owner', FieldLocation.GeneralTab)">
          <input matInput required formControlName="owner" maxlength="500" placeholder="Enter Owner Email"
            [matAutocomplete]="ownerAuto">
          <mat-autocomplete #ownerAuto="matAutocomplete"
            (optionSelected)="onEmailAutocompleteSelected($event, 'owner', 'ownerFullName')">
            <mat-option *ngFor="let email of getEmailAutocompleteOptions('owner')" [value]="email">
              {{ email }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="getErrorMessage('owner') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <mat-form-field class="full-width">
          <textarea matInput formControlName="ownerFullName" maxlength="500" placeholder="Owner Full Name"
            readonly></textarea>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">{{displayNames["closedOn"]}}</label>
        <mat-form-field class="full-width">
          <input matInput formControlName="closedOn" [matDatepicker]="closedOnDatepicker">
          <mat-datepicker-toggle matSuffix [for]="closedOnDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #closedOnDatepicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["resolutionTargetDate"]}}
          @if (!resolutionTargetDate.disabled) {
          <span class="required"></span>
          }
        </label>
        <mat-form-field class="full-width">
          <input matInput readonly required formControlName="resolutionTargetDate"
            [matDatepicker]="resolutionTargetDatepicker" [min]="today" (click)="resolutionTargetDatepicker.open()"
            placeholder="Select a Date">
          @if (form.get('resolutionTargetDate')?.value) {
          <mat-icon class="clear-date" matDatepickerToggleIcon
            (click)="clearDate('resolutionTargetDate')">clear</mat-icon>
          }
          <mat-datepicker-toggle matSuffix [for]="resolutionTargetDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #resolutionTargetDatepicker></mat-datepicker>
          <mat-error *ngIf="getErrorMessage('resolutionTargetDate') as errorMessage">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">
          {{displayNames["resolutionDateExplanation"]}}
          @if (!form.get('resolutionDateExplanation')?.disabled) {
          <span class="required"></span>
          }
        </label>
        <mat-form-field class="full-width">
          <textarea matInput required cdkTextareaAutosize="" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"
            formControlName="resolutionDateExplanation" maxlength="20001"
            placeholder="Enter Resolution Date Explanation"></textarea>
          <mat-error *ngIf="getErrorMessage('resolutionDateExplanation') as errorMessage">{{ errorMessage
            }}</mat-error>
        </mat-form-field>
      </div>

      <div class="horizontal-form-field">
        <label class="form-label">{{displayNames["revisions"]}}</label>
        <!--TODO: Filled automatically.
                When report is recycled on any status before Plan Approved – field stays empty.
                When report is recycled after Plan Approved status – after user clicks on Send draft for review – should be automatically filled by Revision 1 (based on sequence). -->
        <mat-form-field class="full-width">
          <input matInput formControlName="revisions" maxlength="20000" readonly>
        </mat-form-field>
      </div>

      @if (
        reportType.value === ReportType.IntegrityDeficiency ||
        reportType.value === ReportType.ReliabilityDeficiency ||
        reportType.value === ReportType.TaskDeferral
      ) {

        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["created"]}}</label>
          <mat-form-field class="full-width">
            <input matInput formControlName="created" maxlength="20000" readonly>
          </mat-form-field>
        </div>

        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["daysForApproval"]}}</label>
          <mat-form-field class="full-width">
            <input matInput formControlName="daysForApproval" maxlength="20000" readonly>
          </mat-form-field>
        </div>

        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["planApprovalDueDate"]}}</label>
          <mat-form-field class="full-width">
            <input matInput formControlName="planApprovalDueDate" maxlength="20000" readonly>
          </mat-form-field>
        </div>

        @if (
          reportType.value === ReportType.IntegrityDeficiency ||
          reportType.value === ReportType.ReliabilityDeficiency
        ) {
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["deviationFoundDate"]}}
              @if (isRequired(deviationFoundDate) && !form.get('deviationFoundDate')?.disabled) {
              <span class="required"></span>
              }
            </label>
            <mat-form-field class="full-width">
              <input matInput readonly formControlName="deviationFoundDate" [matDatepicker]="deviationFoundDatepicker" (click)="deviationFoundDatepicker.open()" placeholder="Select a Date">
              @if (form.get('deviationFoundDate')?.value) {
              <mat-icon class="clear-date" matDatepickerToggleIcon
                (click)="clearDate('deviationFoundDate')">clear</mat-icon>
              }
              <mat-datepicker-toggle matSuffix [for]="deviationFoundDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #deviationFoundDatepicker></mat-datepicker>
              <mat-error *ngIf="getErrorMessage('deviationFoundDate') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        }
      }
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title class="section-title">
      Description
    </mat-card-title>

    <mat-card-content>
      <div>
        <div class="horizontal-form-field">
          <label class="form-label">
            {{displayNames["descriptionEn"]}}
            @if (!form.get('descriptionEn')?.disabled) {
            <span class="required"></span>
            }
          </label>
          <div class="full-width">
            <div class="control-col">
              <angular-editor [id]="'descriptionEn'" formControlName="descriptionEn"
                [config]="configEN"></angular-editor>
              <mat-error *ngIf="getErrorMessage('descriptionEn') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
        </div>
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["descriptionRu"]}}</label>
          <div class="full-width">
            <angular-editor [id]="'descriptionRu'" formControlName="descriptionRu" [config]="configRU"></angular-editor>
            <mat-error *ngIf="getErrorMessage('descriptionRu') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["descriptionKz"]}}</label>
          <div class="full-width">
            <angular-editor [id]="'descriptionKz'" formControlName="descriptionKz" [config]="configKZ"></angular-editor>
            <mat-error *ngIf="getErrorMessage('descriptionKz') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <mat-card>
    <mat-card-title class="section-title">Finding Details</mat-card-title>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">
              {{displayNames["discipline"]}}
              @if (isRequired(discipline) && !form.get('discipline')?.disabled) {
              <span class="required"></span>
              }
            </label>
            <mat-form-field class="full-width">
              <mat-select formControlName="discipline" placeholder="Select Discipline">
                <mat-option *ngFor="let discipline of disciplineOptions" [value]="discipline.title">
                  {{ discipline.title || 'Select Discipline' }}
                  <!-- @if (discipline.email) {
                  <a href="mailto:{{discipline.email}}"><i>({{ discipline.email }})</i></a>
                  } -->
                </mat-option>
              </mat-select>
              <mat-error *ngIf="getErrorMessage('discipline') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["ffsPerformed"]}}</label>
            @if (isTaskDeferralReport() && form.get('ffsPerformed')?.disabled) {
            <div class="form-value-display">{{ getFfsPerformedLabel() }}</div>
            } @else {
            <mat-form-field class="full-width">
              <mat-select formControlName="ffsPerformed" placeholder="Select FFS Performed">
                <mat-option *ngFor="let fitnessForService of fitnessForServices" [value]="fitnessForService.value">{{
                  fitnessForService.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            }
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["findingType"]}}</label>
            @if (isTaskDeferralReport() && form.get('findingType')?.disabled) {
            <div class="form-value-display">{{ getFindingTypeLabel() }}</div>
            } @else {
            <mat-form-field class="full-width">
              <mat-select formControlName="findingType" placeholder="Select Finding Type">
                <mat-option *ngFor="let findingType of findingTypes" [value]="findingType.value">{{ findingType.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            }
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["ffsResult"]}}</label>
            @if (isTaskDeferralReport() && form.get('ffsResult')?.disabled) {
            <div class="form-value-display">{{ getFfsResultLabel() }}</div>
            } @else {
            <mat-form-field class="full-width">
              <mat-select formControlName="ffsResult" placeholder="Select FFS Result">
                <mat-option *ngFor="let ffsResult of ffsResults" [value]="ffsResult.value">{{ ffsResult.label
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
            }
          </div>
        </div>
        <div class="col-sm-6">

          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["retirementDate"]}}
              @if (isRequired(retirementDate) && !form.get('retirementDate')?.disabled) {
              <span class="required"></span>
              }
            </label>
            @if (isTaskDeferralReport() && form.get('retirementDate')?.disabled) {
            <div class="form-value-display">{{ getRetirementDateLabel() }}</div>
            } @else {
            <mat-form-field class="full-width">
              <input matInput readonly formControlName="retirementDate" [matDatepicker]="retirementDatepicker"
                [min]="today" (click)="retirementDatepicker.open()" placeholder="Select a Date">
              @if (form.get('retirementDate')?.value) {
              <mat-icon class="clear-date" matDatepickerToggleIcon
                (click)="clearDate('retirementDate')">clear</mat-icon>
              }
              <mat-datepicker-toggle matSuffix [for]="retirementDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #retirementDatepicker></mat-datepicker>
              <mat-error *ngIf="getErrorMessage('retirementDate') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
            }

          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["shutDownRequired"]}}</label>
            <mat-form-field class="full-width">
              <mat-select formControlName="shutDownRequired" placeholder="Select Shutdown Option">
                <mat-option *ngFor="let shutdownOption of shutdownOptions" [value]="shutdownOption.value">{{
                  shutdownOption.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title class="section-title">
      Damage Mechanisms/ Failure Mode
      @if (isRequired(haveDamageMechanisms) && !haveDamageMechanisms.disabled) {
      <span class="required"></span>
      }
    </mat-card-title>
    <mat-card-content>
      <div>
        <div class="grid-top">
          <button mat-button type="button" color="primary" (click)="addDamageMechanismOrFailureMode()"
            [disabled]="!canEditDamageMechanisms()">
            <mat-icon svgIcon="plus" />
            Add Existing FDM Damage Mechanism / Failure Mode
          </button>
          <button mat-button (click)="refresh()" [disabled]="!canEditDamageMechanisms()">
            <mat-icon svgIcon="rotate" />
            Refresh
          </button>
          <!-- <button mat-button (click)="export()" disabled [disabled]="!canEdit">
            <mat-icon svgIcon="save" />
            Export FDM Damage mechanism/Failure mode
          </button> -->
          <button *ngIf="damageMechanismsDataSource.data.length > 0 && selection.hasValue()" mat-button
            id="removeSelectedRecordbtn" type="button" color="primary" (click)="removeDandFMode()"
            [disabled]="!canEditDamageMechanisms()">
            Remove
          </button>
        </div>
      </div>

      <div class="table-container">
        <div class="table-scroll-wrapper">
          <table mat-table [dataSource]="damageMechanismsDataSource" matSort class="report-table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()" aria-label="Select all"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)" aria-label="Select row"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Title
                <app-table-column-filter class="column-filter" [class.active]="isActive('title')" (filterChange)="applyFilter($event, 'title')" />
              </th>
              <td mat-cell *matCellDef="let mechanism">{{ mechanism.title }}</td>
            </ng-container>

            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Code
                <app-table-column-filter class="column-filter" [class.active]="isActive('code')" (filterChange)="applyFilter($event, 'code')" />
              </th>
              <td mat-cell *matCellDef="let mechanism">{{ mechanism.code }}</td>
            </ng-container>

            <ng-container matColumnDef="nameEN">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Name [EN]
                <app-table-column-filter class="column-filter" [class.active]="isActive('nameEN')" (filterChange)="applyFilter($event, 'nameEN')" />
              </th>
              <td mat-cell *matCellDef="let mechanism">
                <a class="blue-link" [routerLink]="['/damage-mechanisms', 'edit', mechanism.id]">{{ mechanism.nameEn }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="nameRU">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Name [RU]
                <app-table-column-filter class="column-filter" [class.active]="isActive('nameRU')" (filterChange)="applyFilter($event, 'nameRU')" />
              </th>
              <td mat-cell *matCellDef="let mechanism">{{ mechanism.nameRu }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Type
                <app-table-column-filter class="column-filter" [class.active]="isActive('type')" (filterChange)="applyFilter($event, 'type')" />
              </th>
              <td mat-cell *matCellDef="let mechanism">{{ mechanism.type }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
              [class.selected]="selection.isSelected(row)"></tr>

          </table>
        </div>
      </div>
      <br>
      <br>
      <br>
    </mat-card-content>
  </mat-card>

  <div>
    @if (isIntegrityThreat ||isReliabilitThreat)
    {
    <mat-card class="white-mat-card-content">
      <mat-card-title class="section-title">LPO Avoidance</mat-card-title>

      <mat-card-content>
        <div class="row">
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["value"]}}</label>
              <mat-form-field class="full-width">
                <input matInput type="number" placeholder="Provide a number" formControlName="value">
                <mat-error *ngIf="getErrorMessage('value') as errorMessage">{{ errorMessage }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["tonsOfOilEquivalent"]}}</label>
              <mat-form-field class="full-width">
                <input matInput type="number" placeholder="---" formControlName="tonsOfOilEquivalent">
                <mat-error *ngIf="getErrorMessage('tonsOfOilEquivalent') as errorMessage">{{ errorMessage
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["barrelsOfOilEquivalent"]}}</label>
              <mat-form-field class="full-width">
                <input matInput type="number" placeholder="---" formControlName="barrelsOfOilEquivalent">
                <mat-error *ngIf="getErrorMessage('barrelsOfOilEquivalent') as errorMessage">{{ errorMessage
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    }
  </div>


  <!-- References and TLR Section -->
  <mat-card>
    <!-- <mat-card-title class="section-title">References & TLR Entries</mat-card-title> -->
    <mat-card-content>
      <div class="row">
        <!-- Column 1: References -->
        <div class="col-sm-6">
          <h3 class="section-title">References</h3>
          <div class="grid-top">
            <button mat-button type="button" color="primary" (click)="addReference()" [disabled]="!canEdit || isLoadingReferences() || !canAddReferencesOrTlr()">
              <mat-icon svgIcon="plus" />
              Add New Link
            </button>
            <button *ngIf="referencesDataSource.data.length > 0 && referencesSelection.hasValue()"
                    mat-button type="button" color="warn" (click)="deleteReferences()" [disabled]="!canEdit || isLoadingReferences() || !canAddReferencesOrTlr()">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
            @if (isLoadingReferences()) {
              <mat-spinner diameter="24"></mat-spinner>
            }
          </div>

          <div class="table-container">
            <div class="table-scroll-wrapper">
              <table mat-table [dataSource]="referencesDataSource" class="report-table reference-table">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggleReferences() : null"
                                  [checked]="isAllReferencesSelected()"
                                  [indeterminate]="referencesSelection.hasValue() && !isAllReferencesSelected()"
                                  aria-label="Select all"></mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? referencesSelection.toggle(row) : null"
                                  [checked]="referencesSelection.isSelected(row)"
                                  aria-label="Select row"></mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let reference">{{ getTypeLabel(reference.type) }}</td>
                </ng-container>

                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef>Reference Number</th>
                  <td mat-cell *matCellDef="let reference">{{ reference.number }}</td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>Description</th>
                  <td mat-cell *matCellDef="let reference"
                      [matTooltip]="reference.description"
                      matTooltipPosition="above"
                      class="text-cell">
                    <div class="cell-content">{{ reference.description }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let reference">{{ reference.status }}</td>
                </ng-container>
                <ng-container matColumnDef="link" >
                  <th mat-header-cell *matHeaderCellDef>Link</th>
                  <td mat-cell *matCellDef="let reference"
                      [matTooltip]="reference.link"
                      matTooltipPosition="above"
                      class="text-cell">
                    <div class="cell-content">{{ reference.link }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="created" >
                  <th mat-header-cell *matHeaderCellDef>Created On</th>
                  <td mat-cell *matCellDef="let reference">{{ reference.created | date : 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="referencesDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: referencesDisplayedColumns;"
                    (click)="onReferenceClick(row)"
                    [class.selected]="referencesSelection.isSelected(row)"
                    style="cursor: pointer;"></tr>
              </table>
            </div>
          </div>
        </div>

        <!-- Column 2: TLR References -->
        <div class="col-sm-6">
          <h3 class="section-title">TLR References</h3>
          <div class="grid-top">
            <button mat-button type="button" color="primary" (click)="addTlrEntry()" [disabled]="!canEdit || isLoadingTlr() || !canAddReferencesOrTlr()">
              <mat-icon svgIcon="plus" />
              Add New Link
            </button>
            <button *ngIf="tlrEntriesDataSource.data.length > 0 && tlrEntriesSelection.hasValue()"
                    mat-button type="button" color="warn" (click)="deleteTlrEntries()" [disabled]="!canEdit || isLoadingTlr() || !canAddReferencesOrTlr()">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
            @if (isLoadingTlr()) {
              <mat-spinner diameter="24"></mat-spinner>
            }
          </div>

          <div class="table-container">
            <div class="table-scroll-wrapper">
              <table mat-table [dataSource]="tlrEntriesDataSource" class="report-table tlr-table">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggleTlrEntries() : null"
                                  [checked]="isAllTlrEntriesSelected()"
                                  [indeterminate]="tlrEntriesSelection.hasValue() && !isAllTlrEntriesSelected()"
                                  aria-label="Select all"></mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? tlrEntriesSelection.toggle(row) : null"
                                  [checked]="tlrEntriesSelection.isSelected(row)"
                                  aria-label="Select row"></mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="tag">
                  <th mat-header-cell *matHeaderCellDef>Tag</th>
                  <td mat-cell *matCellDef="let entry">
                    @if (isTLRInActive()) {
                      {{ entry.tag }}
                    } @else {
                      <a *ngIf="entry.tag" href="{{ entry.tag }}" target="_blank" rel="noopener noreferrer" class="blue-link">{{ entry.tag }}</a>
                    }
                    <span *ngIf="!entry.tag">—</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="tlrType">
                  <th mat-header-cell *matHeaderCellDef>TLR Type</th>
                  <td mat-cell *matCellDef="let entry">{{ getTlrTypeLabel(entry.tlrType) }}</td>
                </ng-container>

                <ng-container matColumnDef="taScope">
                  <th mat-header-cell *matHeaderCellDef>TA Scope</th>
                  <td mat-cell *matCellDef="let entry">{{ getTaScopeLabel(entry.taScope) }}</td>
                </ng-container>

                <ng-container matColumnDef="equipmentProcessService">
                  <th mat-header-cell *matHeaderCellDef>Equipment/Process/Service</th>
                  <td mat-cell *matCellDef="let entry">{{ getEquipmentProcessServiceLabel(entry.equipmentProcessService) }}</td>
                </ng-container>

                <ng-container matColumnDef="dateTlrInstalled">
                  <th mat-header-cell *matHeaderCellDef>Date TLR Installed</th>
                  <td mat-cell *matCellDef="let entry">{{ entry.dateTlrInstalled | date : 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="recommendedPermanentRepairDate">
                  <th mat-header-cell *matHeaderCellDef>Recommended Repair Date</th>
                  <td mat-cell *matCellDef="let entry">{{ entry.recommendedPermanentRepairDate | date : 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="tlrEntriesDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: tlrEntriesDisplayedColumns;"
                    (click)="onTlrClick(row)"
                    [class.selected]="tlrEntriesSelection.isSelected(row)"
                    [style.cursor]="isTLRInActive() ? 'initial' : 'pointer'"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>

